














import { Vue, Component, Prop } from 'vue-property-decorator'
import SkillHeader from '@/components/layouts/SkillHeader.vue'
import SkillDescript from '@/components/layouts/SkillDescript.vue'
import { SkillSubtree } from '@/static/ts/skill'

@Component({
  components: {
    SkillHeader,
    SkillDescript
  }
})
export default class SkillSubroot extends Vue {
  @Prop() private subroot!: SkillSubtree
  @Prop() private title!: string
}
